import { FC } from "react";
import { Box, Button } from "@mui/material";
import { styles } from "../stylesForgotPassword";
import { books } from "@/assets/books";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { schemaEmail } from "../scheme";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { setEmail } from "@/store/slice/authForgotPasswordSlice";
import { useForgotPasswordMutation } from "@/store/api/authApi";
import HeaderControl from "@/pages/SignUp/components/HeaderControl";
import TitleBlock from "@/pages/SignUp/components/TitleBlock";
import CustomInput from "@/components/UI/CustomInput/CustomInput";
import BottomLink from "@/pages/SignUp/components/BottomLink";

interface IForgotPasswordProps {
  setForgotPassword: (value: number) => void;
}
type FormInput = {
  email: string;
};
const EnterEmail: FC<IForgotPasswordProps> = ({ setForgotPassword }) => {
  const [forgotPassword] = useForgotPasswordMutation();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormInput>({
    resolver: yupResolver(schemaEmail),
    mode: "all",
  });

  const emailValue = watch("email");

  const dispatch = useAppDispatch();
  const onSubmit = async (data: FormInput) => {
    dispatch(setEmail(data.email));
    await forgotPassword(data).unwrap();
    setForgotPassword(1);
  };

  return (
    <Box sx={styles.wrapper}>
      <HeaderControl onClick={() => history.back()} logo />

      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{ width: "100%", marginTop: "32px" }}
      >
        <TitleBlock
          title={"Forgot your password?"}
          subtitle="Enter your email address below and we’ll send you a code to log in and reset your password."
        />

        <Box marginTop={"44px"}>
          <CustomInput
            label="Email"
            placeholder="Enter your email"
            error={!!errors.email}
            helperText={errors.email?.message || null}
            register={register}
            name="email"
          />

          <Box>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={!emailValue || !!errors.email?.message}
              sx={styles.continueButton}
            >
              Continue
            </Button>

            <BottomLink
              sx={{ mt: 4 }}
              text=" Remember your password?"
              linkText="Log in"
              href={books.login}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default EnterEmail;
